import Logo from './assets/logo.svg'
import LogoWordmark from './assets/logoWordmark.svg'

export const MCLogo = () => (
  <div className='d-flex'>
    <Logo className='mc-icon mc-icon--4 mc-text-color--primary' />
    <LogoWordmark
      className='d-none d-lg-block mc-ml-2 mc-icon'
      style={{ width: 100 }}
    />
  </div>
)
